import { render, staticRenderFns } from "./LottoPayment.vue?vue&type=template&id=4f791830&scoped=true&"
import script from "./LottoPayment.vue?vue&type=script&lang=ts&"
export * from "./LottoPayment.vue?vue&type=script&lang=ts&"
import style0 from "./LottoPayment.vue?vue&type=style&index=0&id=4f791830&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f791830",
  null
  
)

export default component.exports